import type { AlternatesBlock } from "@/i18n/alternates";
import { toAbsoluteUrl } from "@/lib/absolute-url";
import {
  DEFAULT_VIEWER_LOCALE,
  VIEWER_LOCALES,
  type ViewerLocale,
} from "@garimpa/lib/viewerPreferences";

import { buildLandingPagePath } from "./build-landing-page-path";
/** Builds reciprocal canonical and hreflang URLs for one campaign landing family. */
export function buildLandingPageAlternates(current: ViewerLocale, slug: string): AlternatesBlock {
  const languages = Object.fromEntries(
    VIEWER_LOCALES.map((locale) => [locale, toAbsoluteUrl(buildLandingPagePath(locale, slug))]),
  );

  return {
    canonical: toAbsoluteUrl(buildLandingPagePath(current, slug)),
    languages: {
      ...languages,
      "x-default": languages[DEFAULT_VIEWER_LOCALE]!,
    },
  };
}
